import { render, staticRenderFns } from "./JsonSchemaTreeNode.vue?vue&type=template&id=2898ec16&scoped=true&"
import script from "./JsonSchemaTreeNode.vue?vue&type=script&lang=js&"
export * from "./JsonSchemaTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./JsonSchemaTreeNode.vue?vue&type=style&index=0&id=2898ec16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2898ec16",
  null
  
)

export default component.exports